export default __webpack_public_path__ + "static/media/icn-rpm.c7164935.svg";